<template>
    <form class="checkout" action="/basket/create" method="POST" ref="form" @submit.prevent="createOrder(true)">
        <div class="loader" v-show="processing"></div>

        <div class="checkout__order-type" v-if="$root.city.delivery && $root.shops.length">
            <radio-slider v-model="$root.orderType" name="order-type" :inputs="orderTypeInputs" @input="promocodeFieldConditionChange"></radio-slider>
            <div v-show="isDelivery" class="checkout__delivery-price">
                <span class="delivery">
                    Доставка: <span :class="{ currency: $root.deliveryInfo.price !== undefined }">{{ $root.deliveryInfo.price === undefined ? '(адрес не задан)' : $root.deliveryInfo.price }}</span>
                </span>

                <template v-if="$root.deliveryInfo.price > 0 && $root.deliveryInfo.sumToFreeDiff > 0">
                    <span class="checkout__delivery-price--hint">(До бесплатной доставки осталось: <span class="currency">{{ $root.deliveryInfo.sumToFreeDiff }}</span>)</span>
                </template>
            </div>
        </div>

        <div class="form-group form-group--delivery-info">
            <div class="form-group__title">{{ isDelivery ? 'Куда доставить?' : 'Где желаете забрать заказ?' }}</div>

            <div class="input-group">

                <label class="label--name">
                    <input type="text" v-model="name" name="name" required>
                    <span>Ваше имя</span>
                </label>

                <label class="label--phone">
                    <input type="tel" name="phone" v-model="phone" :data-empty="`${!phone}`" ref="phone" pattern="\+7 \([\d]{3}\) [\d]{3}-[\d]{2}-[\d]{2}" required>
                    <span>Ваш телефон</span>
                </label>

                <address-select v-if="!isDelivery" v-model="shopId" name="shop" @change="promocodeFieldConditionChange"></address-select>

                <label v-if="isDelivery">
                    <input type="text" name="address" class="readonly" v-model="$root.stringAddress" :data-empty="`${!$root.stringAddress}`" @click="$root.openModal('select-delivery-address')" required>
                    <span>Ваш адрес</span>
                </label>

                <label>
                    <textarea v-model="comment" name="comment" rows="1" maxlength="500"></textarea>
                    <span>Комментарий к заказу</span>
                </label>

                <div class="input-group__hint">* - поля, обязательные для заполнения</div>
            </div>
        </div>

        <div class="form-group form-group--pickup-time">
            <div class="form-group__title">Время получения заказа *</div>

            <div class="shipping-type__wrapper">
                <label>
                    <input v-model="orderTimeType" @change="promocodeFieldConditionChange" type="radio" name="shipping-type" value="soon" required>
                    <span>В ближайшее время</span>
                </label>

                <label>
                    <input v-model="orderTimeType" @change="promocodeFieldConditionChange" type="radio" name="shipping-type" value="time" required>
                    <span>В указанное время</span>
                </label>
            </div>

            <div v-show="orderTimeType === 'time'" class="shipping-date-time">
                <label class="shipping-date-time__label">
                    <input type="datetime-local" ref="shippingDateTime" @input="promocodeFieldConditionChange" :required="orderTimeType === 'time'">
                    <span>Укажите дату и время</span>
                </label>
            </div>
        </div>

        <div v-if="hasUds" class="form-group form-group--uds" :class="{ 'form-group--uds-applied': uds.applied }">
            <div class="form-group__title">Программа лояльности UDS <span class="ml-2 rules-for-using-certificate" style="font-size: 16px"><a href="/udsInformation" class="link link--black link--underline" target="_blank">Правила использования сертификатов</a></span></div>

            <div v-show="uds.applied && uds.needCertificate" class="uds-cert">
                Используется сертификат UDS
            </div>

            <label v-show="!uds.applied" class="uds-cert">
                <input type="checkbox" v-model="uds.needCertificate" :disabled="uds.applied">
                <span>Использовать сертификат UDS</span>
            </label>

            <label class="label--name">
                <input class="vue-masked" type="text" v-model="uds.key" :data-empty="uds.key === null || uds.key === '' ? 'true' : 'false'" data-maska="### ###" pattern="[0-9]{3} [0-9]{3}" :readonly="uds.applied">
                <button v-if="uds.applied" class="btn btn--clear" @click.prevent="clearUds"></button>
                <button v-else class="btn btn-apply btn--gray icon icon--check-gray" @click.prevent="applyUds(uds.key)" :disabled="!uds.key"></button>
                <span v-if="uds.needCertificate">Код сертификата</span>
                <span v-else>Код скидки</span>
            </label>

            <div v-if="uds.applied" class="alert">
                <div>
                    <span>Доступно к списанию {{ uds.customer.points }} баллов</span>
                    <span v-if="uds.receipt.points < uds.customer.points">
                        , оплатить можно до {{ uds.needCertificate ? uds.purchase.pointsPercent : uds.customer.membershipTier.maxScoresDiscount }}% от суммы чека
                    </span>
                </div>
                <div>Ваш статус: {{ uds.customer.membershipTier.name }}</div>
                <div>Кэшбэк: {{ uds.customer.cashbackRate }}%</div>

                <div v-if="uds.needCertificate" class="label--name mt-2">
                    С сертификата будет списано {{ uds.receipt.points }} баллов
                </div>

                <label v-else class="label--name mt-2">
                    <input type="text" v-model="uds.receipt.points" data-empty="false">
                    <span>Сколько баллов списываем?</span>
                </label>

                <div class="mt-2">Будет начислено {{ uds.purchase.cashBack }} баллов</div>
            </div>

            <div v-for="error in uds.errors" class="alert alert--error">{{ error.message }}</div>
        </div>

        <div class="form-group form-group--payment">
            <div class="form-group__title">Оплата *</div>
            <payment-list v-model="payment" :payments="$root.payments"></payment-list>
        </div>

        <div v-show="isCashPayment" class="form-group form-group--cash mt-2">
            <input type="text" class="vue-masked" v-model="cash" data-maska="######" placeholder="С какой суммы подготовить сдачу?" :required="isCashPayment">
            <div class="form-group--cash-buttons">
                <button @click.prevent="setCash(1000)" class="btn btn--white cash-button">1000</button>
                <button @click.prevent="setCash(2000)" class="btn btn--white cash-button">2000</button>
                <button @click.prevent="setCash(5000)" class="btn btn--white cash-button">5000</button>
                <button @click.prevent="setCash(0)" class="btn btn--white cash-button">Без сдачи</button>
            </div>
        </div>

        <div class="form-group form-group--promocode" :class="{ 'form-group--promocode-applied': appliedPromocode }">
            <div class="form-group__title mb-3">Промокод</div>

            <label class="label--name">
                <template v-if="appliedPromocode">
                    <input type="text" v-model="appliedPromocode.key" data-empty="false" readonly :class="{ 'error': promocode.error}">
                    <button class="btn btn--clear" @click.prevent="clearPromocode"></button>
                </template>

                <template v-else>
                    <input type="text" v-model="promocode.key" ref="inputPromocode">
                    <span>Введите промокод и нажмите галочку</span>
                </template>
            </label>

            <template v-if="appliedPromocode">
                <div v-if="!promocode.error" class="alert alert--success">Ваш промокод успешно активирован!</div>
                <div v-else class="alert alert--error">{{ promocode.error }}</div>

                <div class="mt-6" style="grid-column: 1/3" v-if="appliedPromocode.item.type === 'present'">
                    <div v-if="!promocode.error" style="font-size: 1.125rem">К Вашему заказу добавлен:</div>
                    <div v-else style="font-size: 1.125rem; color: var(--color-red);">К Вашему заказу НЕ добавлен:</div>

                    <div class="mt-2">
                        <div class="font-size-3" style="font-size: 1.25rem">{{ appliedPromocode.item.product.name }} <span class="ml-1 currency">{{ parseInt(appliedPromocode.item.sum) }}</span></div>
                        <div class="font-size-1 color-gray">{{ appliedPromocode.item.product.quantityInProduct }} шт / {{ appliedPromocode.item.product.weight.value.original }} {{ appliedPromocode.item.product.weight.unit }}</div>
                    </div>
                </div>
                <div class="mt-3" style="grid-column: 1/3" v-else-if="appliedPromocode.item.type === 'absolutDiscount'">
                    <div v-if="!promocode.error" style="font-size: 1.125rem">
                        Скидка на Ваш заказ {{ appliedPromocode.item.sum }}
                    </div>
                </div>
                <div class="mt-3" style="grid-column: 1/3" v-else-if="appliedPromocode.item.type === 'relativeDiscount'">
                    <div v-if="!promocode.error" style="font-size: 1.125rem">
                        Скидка на Ваш заказ {{ appliedPromocode.item.persent }}%
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="alert alert--error" v-if="promocode.error">{{ promocode.error }}</div>
                <button class="btn btn-apply btn--gray icon icon--check-gray" :disabled="!promocode.key" @click.prevent="applyPromocode(promocode.key)"></button>
            </template>
        </div>

        <div class="form-group form-group--errors" v-if="$root.basket.cart.price.total < $root.deliveryInfo.minOrder">
            <div class="error" v-if="$root.basket.cart.price.total < $root.deliveryInfo.minOrder">⚠️ Недостаточная сумма заказа. Минимальная сумма доставки <span class="currency">{{ $root.deliveryInfo.minOrder }}</span></div>
        </div>

        <label class="privacy-policy mt-4" style="grid-area: privacy-policy">
            <input type="checkbox" v-model="accept" required>
            <span>Согласен с <a href="/terms" class="link link--black link--underline" target="_blank">политикой конфиденциальности</a></span>
        </label>

        <div class="form-group form-group--create-order">
            <div class="total">Итого: <span class="currency currency--top">{{ payload.payment.total | numberFormat }}</span></div>
            <button type="submit" class="btn" @click="$refs.form.classList.add('submitted')" :class="{
                'btn--disabled': !canOrderSubmit,
                'btn--gray': !canOrderSubmit,
                'btn--success': canOrderSubmit
            }">Заказать</button>
        </div>

        <dialog-info :visible="dialogInfo.visible"
                     :title="dialogInfo.title"
                     :message="dialogInfo.message"
                    @close="dialogInfo.visible = false"/>
        <has-active-order @retry-create-order="retryCreateOrder" />
        <forgot-to-add-modal :visible="forgotToAddModal.visible" @create-without-spices="createOrder" @close="closeForgotToAddModal" />
    </form>
</template>

<script>
import radioSlider from '../radio-slider';
import addressSelect from '../address-select';
import * as Sentry from '@sentry/browser';
import { MaskInput } from 'maska';
import HasActiveOrder from "../modals/hasActiveOrder.vue";
import ForgotToAddModal from "../modals/forgotToAddModal.vue";
import { searchForZonesByCoordinates } from "../../axios/axios_geocoder";

export default {
    components: {
        ForgotToAddModal,
        HasActiveOrder,
        radioSlider,
        addressSelect
    },

    data: function () {
        return {
            orderTypes: [
                {
                    name: 'Доставка',
                    slug: 'delivery'
                },
                {
                    name: 'Самовывоз',
                    slug: 'takeaway'
                }
            ],

            accept: false,
            name: '',
            phone: '',
            shippingDateTime: null,

            payment: null,
            shopId: null,
            orderTimeType: null,
            comment: '',
            cash: null,

            promocode: {
                key: '',
                error: null
            },

            uds: {
                key: '',
                applied: false,
                needCertificate: false,
                errors: [],
                customer: {
                    cashbackRate: null,
                    points: null,
                    membershipTier: {
                        maxScoresDiscount: null,
                        name: null,
                        uid: null,
                    },
                },

                receipt: {
                    total: 0,
                    points: 0,
                },

                purchase: {
                    cash: 0,
                    total: 0,
                    points: 0,
                    certificatePoints: 0,
                    maxPoints: 0,
                    cashBack: 0,
                    pointsPercent: 0,
                }
            },
            createAnyway: false,

            processing: false,
            forgotToAddModal: {
                visible: false
            },
            dialogInfo: {
                visible: false,
                title: '',
                message: ''
            }
        };
    },

    methods: {
        searchForZonesByCoordinates,
        async createOrder(checkSpices = false) {
            if (checkSpices && this.hasRelatedProducts && !this.orderWithSpices()) {
                this.openForgotToAddModal()
                return
            }

            this.processing = true;

            if (this.uds.key) {
                await this.applyUds(this.uds.key, this.uds.receipt.points)
            }

            axios.post('/basket/create', this.payload)
                .then((response) => {
                    if (!response.data.orderId) return;

                    this.$root.createdOrder = response.data;
                    this.$root.createdOrder.payload = this.payload;
                    this.$root.openModal('order-created');
                    if (response.data.orderId) this.$root.openModal('order-created');

                    this.$eventBus.$emit('order-created');
                })
                .catch((error) => {
                    if (!error.response) {
                        Sentry.captureException(error);
                        alert('Что-то пошло не так. Попробуйте еще раз');
                        return;
                    }

                    if (error.response.data.errors && error.response.data.errors?.activeOrder) {
                        this.$root.openModal('has-active-order', { message: error.response.data.message })
                        return;
                    }

                    if (error.response.data.errors && error.response.data.errors.date) {
                        this.dialogInfo.visible = true;
                        this.dialogInfo.title = error.response.data.errors.date[0];
                        this.dialogInfo.message = error.response.data.message;
                        return;
                    }

                    const errors = Array.isArray(error.response.data.errors) ? error.response.data.errors : [ { message: error.response.data.message } ];

                    if (!errors.length) {
                        errors.push({ message: 'Произошла ошибка при выполнении запроса' });
                        Sentry.captureException(error);
                    }

                    this.dialogInfo.title = 'Внимание';
                    this.dialogInfo.message = errors.map((item) => item.message).filter((item) => item).join('\n');
                    this.dialogInfo.visible = true;
                })
                .then(() => {
                    this.processing = false;
                    this.createAnyway = false
                });
        },

        orderWithSpices() {
            const relatedProductsIds = Object.keys(this.$root.basket.cart.related)
            if (!relatedProductsIds.length)
                return true

            const goodsIds = Object.keys(this.$root.basket.cart.goods).map(key => {
                return String(this.$root.basket.cart.goods[key].id)
            })

            for (const goodsIdsKey of goodsIds) {
                if (relatedProductsIds.includes(goodsIdsKey))
                    return true
            }
            return false
        },
        retryCreateOrder() {
            this.createAnyway = true
            this.createOrder()
        },

        async applyPromocode(promocode) {
            if (!promocode) {
                return;
            }

            if (this.uds.applied) {
                this.promocodeAndUdsWarning();
                this.promocode.key = '';
                return;
            }

            promocode = promocode.replace(' ', '');
            this.processing = true;

            const response = (await axios.get('/api/order/promocode/apply', {
                params: {
                    order_type: this.$root.orderType,
                    promocode: promocode,
                    shop_id: this.shopId,
                    order_time_type: this.orderTimeType,
                    order_date: this.shippingDateTime?.toISOString(),
                    timezone: this.$root.city.timeZoneOffsetInHours
                }
            })
                .catch((error) => ({ data: { success: false, error: { message: error.message } } }))
            ).data;

            if (!response.success) {
                this.promocode.error = response?.error?.message ?? 'Упс... Что-то пошло не так :(';
            }

            this.$root.basket = await this.getCart();

            this.processing = false;

            this.$nextTick(() => {
                this.checkConditionsPromocode();
            });
        },

        async checkConditionsPromocode() {
            let error = false;

            const conditions = this.appliedPromocode?.item?.conditions || [];
            conditions.forEach((condition) => {
                switch (condition.type) {
                    case 'typeOrder':
                        if (!condition.value.includes(this.$root.orderType)) {
                            error = true;
                        }
                        break;
                    case 'orderPrice':
                        if (condition.value > this.$root.basket.cart.price.subtotal) {
                            error = true;
                        }
                        break;
                    case 'shopIds':
                        if (!condition.value.includes(this.shopId)) {
                            error = true;
                        }
                        break;
                    case 'today':
                        let now = window.moment().startOf('day');
                        let orderDate = window.moment(this.shippingDateTime?.toISOString()).startOf('day');

                        if (this.orderTimeType === 'soon') {
                            break;
                        }

                        if (
                            !this.orderTimeType ||
                            !this.shippingDateTime?.toISOString() ||
                            (this.orderTimeType === 'time' && now.diff(orderDate, 'days') !== 0)
                        ) {
                            error = true;
                        }

                        break;
                    case 'timeLimit':
                        let orderDateTime = window.moment();
                        let timeStart = window.moment(condition.value.start, 'h:mm');
                        let timeEnd = window.moment(condition.value.end, 'h:mm');

                        if (!orderDateTime.isBetween(timeStart, timeEnd)) {
                            error = true;
                        }
                        break;
                    case 'orderInProducts':
                        const cartIds = Object.keys(this.$root.basket.cart.goods).map(key => this.$root.basket.cart.goods[key].id);
                        if (condition.value.filter(item => cartIds.includes(item)).length !== condition.value.length) {
                            error = true
                        }
                        break;
                    case 'weekDay':
                        if (!condition.value.includes(window.moment().isoWeekday().toString())) {
                            error = true;
                        }
                        break;
                }
            })

            this.promocode.error = error ? 'Условия активации не соблюдены' : '';

            return error;
        },

        async promocodeFieldConditionChange() {
            this.checkConditionsPromocode();
            this.applyPromocode(this.appliedPromocode?.key);
        },

        async clearPromocode() {
            const responseClear = (await axios.get('api/order/promocode/clear')).data;
            if (!responseClear.success) return alert('Упс... Что-то пошло не так :(');

            this.$root.basket = await this.getCart();

            this.$nextTick(() => {
                this.$refs.inputPromocode.dataset.empty = true;
                this.promocode = {
                    key: '',
                    error: null
                };
            });
        },

        async getCart() {
            return axios.post('/basket/actualize')
                .catch((error) => {
                    if (error.message === 'canceled') {
                        return alert('Упс... Кажется у вас отключены cookie! Мы не сможем гарантировать работу сайта, пока вы их не включите :(')
                    } else {
                        Sentry.captureException(error);
                    }
                })
                .then((response) => response?.data || this.$root.basket);
        },

        clearUds() {
            this.uds.key = '';
            this.uds.applied = false;
            this.uds.errors = [];
            this.uds.customer = {
                cashbackRate: null,
                points: null,
                membershipTier: {
                    maxScoresDiscount: null,
                    name: null,
                    uid: null,
                },
            };
        },

        async promocodeAndUdsWarning() {
            this.dialogInfo.title = 'Внимание';
            this.dialogInfo.message = 'Нельзя одновременно использовать промокод и списывать баллы UDS';
            this.dialogInfo.visible = true;
        },

        async applyUds(code, points = 0) {
            if (this.appliedPromocode) {
                this.promocodeAndUdsWarning();
                this.uds.key = '';
                return;
            }

            this.processing = true;

            const total = this.$root.basket.cart.price.total + (this.$root.deliveryInfo.price || 0) - (this.promocode.error ? (this.appliedPromocode?.item?.sum || 0) : 0)

            const response = await axios.post('/api/uds/calculateOperation', {
                code: code.replace(' ', ''),
                total: total,
                points: points,
            })
                .catch((error) => {
                    if (!error?.response || !error?.response?.data?.errors) {
                        Sentry.captureException(error);

                        return {
                            data: {
                                errors: [
                                    {
                                        message: 'Упс... Что-то пошло не так. Попробуйте еще раз :('
                                    }
                                ]
                            }
                        };
                    }

                    return error.response;
                });

            this.processing = false;

            this.uds.errors = response.data.errors || [];

            if (this.uds.errors.length === 0 && this.uds.needCertificate && response.data.purchase.certificatePoints === 0) {
                this.uds.errors.push({
                    message: 'Вы хотите использовать сертификат UDS, но ввели код скидки.'
                });
            }

            if (this.uds.errors.length === 0 && !this.uds.needCertificate && response.data.purchase.certificatePoints !== 0) {
                this.uds.errors.push({
                    message: 'Вы ввели код сертификата, но ожидался код скидки.'
                });
            }

            this.uds.applied = this.uds.errors.length === 0;

            if (this.uds.applied) {
                this.uds.customer = response.data.user;
                this.uds.purchase = response.data.purchase;
                this.uds.receipt.points = Math.floor(response.data.purchase.points);
                this.uds.receipt.total = response.data.purchase.total;

                this.uds.customer.points = Math.floor(this.uds.customer.points);
                this.uds.purchase.maxPoints = Math.floor(this.uds.purchase.maxPoints);
                this.uds.purchase.points = Math.floor(this.uds.purchase.points);
                this.uds.purchase.pointsPercent = Math.floor(this.uds.purchase.pointsPercent);
                this.uds.purchase.total = Math.floor(this.uds.purchase.total)
                this.uds.purchase.cash = Math.ceil(this.uds.purchase.cash)

                if (this.uds.purchase.certificatePoints > 0) {
                    this.uds.receipt.points = Math.floor(this.uds.purchase.maxPoints);
                }
            }
        },

        setCash(value) {
            this.cash = value
        },

        checkDateTime(date) {
            const timestr = date.substring(11)
            const select = window.moment().startOf('day')
            select.add(timestr.substring(0,2), 'hours').add(timestr.substring(3), 'minutes')

            let from = null
            let to = null

            if (this.isDelivery) {
                const workingTime = this.$root.deliveryWorkingTime.default[0]
                from = window.moment().startOf('day').add(workingTime.from, 'minutes')
                to = window.moment().startOf('day').add(workingTime.to, 'minutes')
            } else {
                if (!this.shopId) {
                    return false;
                }
                const workingTime = this.shop.workingHours
                    .filter(item => item.date === null)
                    .filter(item => item.type === 'default')
                    .find(item => {
                        return item.day === 1
                    })

                from = window.moment().startOf('day').add(workingTime.from, 'minutes')
                to = window.moment().startOf('day').add(workingTime.to, 'minutes')
            }
            return select.isBetween(from, to, 'minutes', '[]')
        },

        closeForgotToAddModal() {
            this.forgotToAddModal.visible = false
        },
        openForgotToAddModal() {
            this.forgotToAddModal.visible = true
        },
        async getOrderData() {
            await this.applyPromocode(this.promocode.key ? this.promocode.key : this.appliedPromocode?.key);
        }
    },

    computed: {
        hasUds() {
            return window.initialState.hasUds;
        },

        orderTypeInputs() {
            return this.orderTypes.map((orderType) => ({
                label: orderType.name,
                value: orderType.slug
            }));
        },

        isDelivery() {
            return this.$root.orderType === 'delivery'
        },

        canOrderSubmit() {
            const payload = this.payload;
            let canOrderSubmit = true;

            canOrderSubmit = canOrderSubmit && !!payload.name;
            canOrderSubmit = canOrderSubmit && !!payload.phone;
            canOrderSubmit = canOrderSubmit && !!this.accept;
            canOrderSubmit = canOrderSubmit && !!payload.payment.slug;
            canOrderSubmit = canOrderSubmit && !!payload.time.type;
            canOrderSubmit = canOrderSubmit && !this.processing

            if (payload.type === 'delivery') {
                canOrderSubmit = canOrderSubmit && !!payload.delivery.found;
                canOrderSubmit = canOrderSubmit && !!payload.delivery.delivered;
                canOrderSubmit = canOrderSubmit && !!payload.delivery.formated;
                canOrderSubmit = canOrderSubmit && (this.$root.basket.cart.price.total >= this.$root.deliveryInfo.minOrder);
            } else {
                canOrderSubmit = canOrderSubmit && !!payload.shop.id;
            }

            if (payload.time.type === 'time') {
                canOrderSubmit = canOrderSubmit && !!payload.time.value.date;
                canOrderSubmit = canOrderSubmit && !!payload.time.value.time;
            }

            if (payload.payment.slug === 'cash') {
                canOrderSubmit = canOrderSubmit && !(payload.payment.change === null || payload.payment.change === '')
            }

            return canOrderSubmit;
        },

        appliedPromocode() {
            return this.$root.basket.cart.promocode;
        },

        payload() {
            if (isNaN(this.shippingDateTime)) this.shippingDateTime = null;

            const payload = {
                phone: this.phone,
                accountPhone: this.phone,
                name: this.name,
                comment: this.comment,
                city_id: this.$root.city.id,

                type: this.$root.orderType,
                shop: { id: this.shopId },

                time: {
                    type: this.orderTimeType,
                    value: {
                        date: this.shippingDateTime?.toISOString().split('T')[0],
                        time: this.shippingDateTime ? `${('0' + this.shippingDateTime.getHours()).slice(-2)}:${('0' + this.shippingDateTime.getMinutes()).slice(-2)}` : undefined
                    }
                },

                payment: {
                    id: this.payment?.id,
                    slug: this.payment?.slug,
                    subtotal: this.$root.basket.cart.price.subtotal,
                    delivery: this.$root.deliveryInfo.price,
                    total: this.$root.basket.cart.price.total - (this.uds.applied ? this.uds.receipt.points : 0) + (this.$root.deliveryInfo.price || 0),
                    change: this.cash
                },

                delivery: this.isDelivery ? this.$root.addr : false,
                createAnyway: this.createAnyway,
                channel: 'desktop'
            };

            if (this.uds.applied) {
                payload.uds = {
                    code: this.uds.key,
                    points: this.uds.receipt.points,
                    cash: this.uds.purchase.cash,
                    total: this.uds.purchase.total
                };
            }

            return payload;
        },

        isCashPayment() {
            return this.payment?.slug === 'cash'
        },

        shop() {
            return this.$root.shops.find(item => item.id === this.shopId)
        },

        time() {
            const startOfDay = window.moment().startOf('day')
            let workingTime = null
            if (this.isDelivery) {
                workingTime = this.$root.deliveryWorkingTime.default[0]
            } else {
                if (!this.shopId) {
                    return {
                        minTime: '00:00',
                        maxTime: '23:59'
                    };
                }
                workingTime = this.shop.workingHours
                    .filter(item => item.date === null)
                    .filter(item => item.type === 'default')
                    .find(item => {
                        return item.day === 1
                    })
            }

            const from = startOfDay.clone().add(workingTime.from, 'minutes')
            const to = startOfDay.clone().add(workingTime.to, 'minutes')

            const time = {
                minTime: null,
                maxTime: to.format('HH:mm')
            }

            const now = window.moment()

            if (now > from) {
                time.minTime = new Date()
            } else {
                time.minTime = from.format('HH:mm')
            }

            return time
        },
        changeTime() {
            return JSON.stringify(this.time)
        },
        hasRelatedProducts() {
            return !!Object.keys(this.$root.basket.cart.related).length
        }
    },

    mounted() {
        this.getOrderData();
        if (window.screen.width > 549) {
            $(this.$refs.shippingDateTime).attr('type', 'text');
            $(this.$refs.shippingDateTime).attr('pattern', '[0-9]{2}.[0-9]{2}.[0-9]{4} [0-9]{2}:[0-9]{2}');

            $(this.$refs.shippingDateTime).datetimepicker({
                scrollMonth: false,
                scrollInput: false,
                dayOfWeekStart: 1,
                format: 'd.m.Y H:i',
                formatDate: 'Y-m-d',
                formatTime: 'H:i',
                mask: true,
                step: 15,
                timepicker: true,
                minTime: this.time.minTime,
                maxTime: this.time.maxTime,
                minDate: 0,
                closeOnDateSelect:false,
                onChangeDateTime: (date) => {
                    this.shippingDateTime = date
                },
            }).val('').change((event) => {
                event.target.dataset.empty = ['', undefined].includes(event.target.value?.trim()) || !this.checkDateTime(event.target.value)
                if (event.target.dataset.empty === true || event.target.dataset.empty === 'true') {
                    $(this.$refs.shippingDateTime).datetimepicker('reset')
                }
            });
        } else {
            this.$refs.shippingDateTime.addEventListener('input', (event) => {
                this.shippingDateTime = new Date(event.target.value);
            })
        }

        $(this.$refs.phone).extramask();
        new MaskInput('.vue-masked');

        $('.readonly').on('keydown paste mousedown', (e) => {
            // ignore tabs
            if (e.keyCode !== 9) e.preventDefault();
        });

        this.checkConditionsPromocode();

        if (this.$root.addr.coordinates) {
            this.searchForZonesByCoordinates()
                .then(({data}) => {
                    this.$root.addr.requirements = {
                        sum_to_paid_delivery: data.requirements.sum_to_paid_delivery,
                        sum_to_free_delivery: data.requirements.sum_to_free_delivery,
                        sum_to_min_order: data.requirements.sum_to_min_order,
                        delivery_time_min: data.requirements.delivery_time_min
                    };
                });
        }
    },

    watch: {
        changeTime() {
            if (window.screen.width > 549 && $(this.$refs.shippingDateTime)) {
                $(this.$refs.shippingDateTime).datetimepicker('setOptions', {minTime: this.time.minTime, maxTime: this.time.maxTime})
            }
        },

        orderTimeType() {
            if (this.orderTimeType === 'soon') {
                $(this.$refs.shippingDateTime)?.attr('pattern', null)
            } else {
                $(this.$refs.shippingDateTime).attr('pattern', '[0-9]{2}.[0-9]{2}.[0-9]{4} [0-9]{2}:[0-9]{2}')
            }

            this.checkConditionsPromocode();
        },

        '$root.basket.cart': function (cart) {
            const clientHeight_new = document.querySelector('.container .basket-items').clientHeight;

            if (global.clientHeight_old) {
                document.body.parentElement.style.scrollBehavior = 'auto';
                window.scrollTo(0, window.scrollY + (clientHeight_new - global.clientHeight_old));
                document.body.parentElement.style.scrollBehavior = null;
            }

            global.clientHeight_old = clientHeight_new;

            if (cart.count === 0) {
                window.location = '/'
                return
            }

            this.$nextTick(() => {
                this.checkConditionsPromocode();
                if (this.uds.applied)
                    this.applyUds(this.uds.key, this.uds.receipt.points)
            });
        },

        appliedPromocode() {
            this.promocode = {
                key: '',
                error: null
            };
        },

        'uds.receipt.points'(value) {
            if (this.uds.purchase.certificatePoints) value = this.uds.purchase.maxPoints;

            this.uds.receipt.points = Math.min(+`${value}`.replace(/\D+/g, ''), this.uds.purchase.maxPoints);
            this.uds.purchase.cashBack = (this.payload.payment.total * 0.01 * this.uds.customer.cashbackRate).toFixed(2);
            this.uds.receipt.cash = this.uds.purchase.total - this.uds.receipt.points
        },

        'uds.key'(value, oldValue) {
            if (value.length === 7 && oldValue.length === 6) {
                this.applyUds(this.uds.key, this.uds.receipt.points);
            }
        },

        'promocode.key'(value, oldValue) {
            if (value.length === 6 && oldValue.length === 5 && /\d{6}/u.test(value)) {
                this.applyPromocode(this.promocode.key);
            }
        },

        '$root.orderType'() {
            if (this.uds.applied) this.applyUds(this.uds.key, this.uds.receipt.points);
            this.checkConditionsPromocode();
        },

        'shippingDateTime'() {
            this.promocodeFieldConditionChange();
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-group--uds label {
        max-width: 420px;
    }
    .form-group--promocode {
        max-width: 420px;

        input::placeholder {
            @media (max-width: 550px) {
                font-size: 12px;
            }
        }
    }
    .rules-for-using-certificate {
        @media (max-width: 550px) {
            display: none;
        }
    }
    .cash-button {
        width: 100px;
        font-size: 14px;
        padding: 18px 0;
        @media (max-width: 550px) {
            width: 80px;
            font-size: 14px;
        }
    }
    form {
        @media (min-width: 550px) {
            display: grid;
            grid-template-areas:
                'order-type order-type'
                'delivery-info delivery-info'
                'pickup-time pickup-time'
                'uds uds'
                'promocode promocode'
                'payment payment'
                'cash cash'
                'privacy-policy privacy-policy'
                'create-order .';
        }

        .checkout__order-type {
            grid-area: order-type;
        }

        .form-group {
            &--delivery-info {
                grid-area: delivery-info;
            }

            &--pickup-time {
                grid-area: pickup-time;
            }

            &--payment {
                grid-area: payment;
            }

            &--cash {
                max-width: 420px;
                grid-area: cash;
                display: grid;
                gap: 6px;

                @media (max-width: 550px) {
                    grid-template-columns: none;
                    grid-template-rows: auto;
                }
            }

            &--cash-buttons {
                display: grid;
                gap: 6px;
                justify-content: space-between;
                grid-template-columns: repeat(auto-fill, 100px);

                @media (max-width: 550px) {
                    grid-template-columns: repeat(auto-fill, 80px);
                }

            }

            &--errors {
                grid-area: errors;
            }

            &--create-order {
                grid-area: create-order;
            }

            &--promocode {
                grid-area: promocode;
            }

            &--uds {
                grid-area: uds;
            }
        }
    }

    form.submitted:deep(*) {
        *:invalid {
            &, &::before, & ~ .address-select-input {
                border-color: var(--color-red);
            }
        }

        *:valid {
            &, &::before, & ~ .address-select-input {
                border-color: var(--color-green);
            }
        }
    }

    form:deep(.payment-list), form:deep(.form-group--pickup-time) {
        label > input[required] ~ span::after {
            display: none;
        }
    }
</style>
